import styled from 'styled-components';

export const PopupWrapper = styled.div`
  top: calc(100vh - 604px) !important;
  width: calc(100% - 72px);
  right: 20px !important;
  left: 20px!important;
  position: relative;
`

export const PopupContainer = styled.div`
  background-color: #ffffff;
  box-shadow: 0 0 36px rgba(0,0,0,0.15);
  border-radius: 16px 16px 20px 20px;
  border-top: 3px solid #417dff;
  width: 100%;
  padding: 20px 16px 8px;
  margin-top: ${p => p.textAreaNumberOfLines ? `calc(120px - ${p.textAreaNumberOfLines * 20}px)` : `100px`} !important;
`;

export const GifContainer = styled.div`
  height: ${props => (props.changeHeight ? 207 : 300)}px;
  overflow-x: hidden;
  overflow-y: auto;
  margin: 16px -8px 10px 0;
  padding-right: 8px;
  /* width */
  ::-webkit-scrollbar {
    width: 4px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #FFFFFF;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {

    background: #DADDE4;
    border-radius: 12px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const GifLayout = styled.div`
  grid-gap: 8px;
  columns: 2;
`;

export const GifPreview = styled.img`
  width: 100%;
  height: ${props => props.height}px;
  display: block;
  margin-bottom: 8px;
  border-radius: 4px;
  cursor: pointer;
  background-color: #f4f5fa;
  border: 2px solid ${props => (props.isSelected ? '#005bfb' : 'transparent')};
  &:hover {
    border: 2px solid #005bfb;
  }
`;

export const PoweredByText = styled.p`
  color: #a2a6ad;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: center;
  margin: 16px 0 0 0;
  span {
    font-weight: 500;
    color: #283446;
  }
`;

export const LoaderContainer = styled.div`
  position: relative;
  margin-top: 10px;
  > div {
    width: 20px;
    height: 20px;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
`;

export const NoSearchText = styled.p`
  width: 233px;
  color: #8f949d;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  text-align: center;
  margin: 20px auto 0;
`;

export const ReplaceBtn = styled.div`
  background: #0a7ef9;
  border-radius: 5px;
  padding: 10px 20px;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: #ffffff;
  margin-left: auto;
  cursor: pointer;
`;

export const TriggerIcon = styled.div`
  margin-right: 16px;
  cursor: pointer;
  align-self: flex-end;
`;
